import {AfterViewInit, Component, inject, PLATFORM_ID} from '@angular/core';
import {LpCtaComponent} from "../../common/lp/lp-cta/lp-cta.component";

import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {loadFAQ} from '../../../../common/faq';

@Component({
  selector: 'app-home-faq',
  imports: [
    LpCtaComponent
  ],
  templateUrl: './home-faq.component.html',
  styleUrl: './home-faq.component.scss'
})
export class HomeFaqComponent implements AfterViewInit {

  platformId = inject(PLATFORM_ID);
  document = inject(DOCUMENT);

  ngAfterViewInit() {

    if (isPlatformBrowser(this.platformId)) {
      loadFAQ(this.document)
    }
  }
}
